import { render, staticRenderFns } from "./WechatCustomerService.vue?vue&type=template&id=b8eb5750&scoped=true"
import script from "./WechatCustomerService.vue?vue&type=script&lang=js"
export * from "./WechatCustomerService.vue?vue&type=script&lang=js"
import style0 from "./WechatCustomerService.vue?vue&type=style&index=0&id=b8eb5750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8eb5750",
  null
  
)

export default component.exports